import React, {useEffect, useState} from 'react'
import { reduxForm, Field, FormSection, formValueSelector,reset,initialize } from 'redux-form'
import {connect, useSelector} from 'react-redux'
import { FormButtons, validations, renderers } from '../../components'
import * as ReactBootstrap from 'react-bootstrap'
import * as rest from '../../services'
import { showErrorToast, showSuccessToast } from '../../state/toasts'
import { useDispatch } from 'react-redux'
import { Slider, ICONS } from '../../components'
import { DevicePartReportForm } from './forms/DevicePartReportForm'
import {getMultipleLists} from "../../state/lists";
const DeliveryFormName = 'delivery-form'
let UpdateDeliveryInfoForm = ({
  handleSubmit,
  pristine,
  reset,
  submitting,
  unit_part_reports,
  unit_parts,
  editMode,
}) => {
   const { user } = useSelector((state) => state.auth)
  const { role, is_superuser } = user

  return (
    <form onSubmit={handleSubmit}>
      <ReactBootstrap.Row>
        <ReactBootstrap.Col md={4} xs={12} lg={6}>
          <Field
            name="actual_service_cost"
            label="Actual Service Cost"
            validate={[validations.required]}
            component={renderers.renderField}
            type="text"
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col md={4} xs={12} lg={6}>
          <Field
            name="actual_hardware_cost"
            label="Actual Hardware Cost"
            validate={[validations.required]}
            component={renderers.renderField}
            type="text"
          />
        </ReactBootstrap.Col>

        <ReactBootstrap.Col md={4} xs={12} lg={6}>
          <Field
            name="estimation_cost"
            label="Estimation"
            component={renderers.renderField}
            type="text"
          />
        </ReactBootstrap.Col>

          {user && (role === 'SuperUser' || is_superuser) && <ReactBootstrap.Col md={4} xs={12} lg={6}>
          <Field
            name="device_pickup_time"
            label="Device Picup Time"
            component={renderers.renderDateTimePicker}
            dateFormat="MMMM d, yyyy h:mm aa"
          />
        </ReactBootstrap.Col>}


        <ReactBootstrap.Col xs="12">
          <Field
            name="action_taken"
            label="Action Taken"
            validate={[validations.required]}
            component={renderers.renderTextArea}
            type="text"
          />
        </ReactBootstrap.Col>

        <ReactBootstrap.Col xs="12">

          <Field
            component={renderers.renderSelectField2}
            as="select"
            validate={[validations.required]}
            name="outward_condition"
              label="Device Outward Condition"
             options={["Part Replacement",
               "Whole Unit Replacement" ,"NTF",
               "Unauthorized Modifications",
               "Requote" ,"Estimation", "Service Decline"].map((opt)=>{
                 return  {
                   "text":opt,
                   "value":opt}
             })}
          >

          </Field>

        </ReactBootstrap.Col>

        <FormSection name="unit_part_reports">
          <ReactBootstrap.Col>
            <h3 className="mt-5">Unit Part Reports</h3>

            <DevicePartReportForm
              unit_parts={unit_parts}
              editMode={editMode}
              unit_part_reports={unit_part_reports}
              FormName={DeliveryFormName}
            />
          </ReactBootstrap.Col>
        </FormSection>
      </ReactBootstrap.Row>
      <FormButtons submitting={submitting} pristine={pristine} reset={reset} />
    </form>
  )
}
UpdateDeliveryInfoForm = reduxForm({
  form: DeliveryFormName,
})(UpdateDeliveryInfoForm)

export const UpdateDeliveryInfo = ({ ticket, onTicketUpdate }) => {
  const dispatch = useDispatch()
  const {unit_part } = useSelector(
    (state) => state.lists
  )
    const loadOptions = () => {
      !unit_part  && dispatch(
          getMultipleLists(["UNIT_PART"]))
  }
   useEffect(()=>{
      loadOptions()
  },[])

  const createOrUpdateDeliveryInfo = (values) => {
    values.ticket = ticket.url

    const promise =
      ticket.delivery && ticket.delivery.url
        ? new rest.DeliveryService(ticket.delivery.url).makePutRequest(values)
        : new rest.DeliveryService().makePostRequest(values)
    promise
      .then((response) => {
        onTicketUpdate({...ticket,delivery:response})
          dispatch(initialize(DeliveryFormName, {...response}));

        dispatch(
          showSuccessToast('Success', 'Delivery Information has been updated.')
        )
      })
      .catch((errors) => {
        dispatch(
          showErrorToast(
            'Error on delivery info update',
            JSON.stringify(errors.response ? errors.response.data : errors)
          )
        )
      })
  }

  let UpdateDeliveryInfoFormData = connect((state) => ({
    initialValues: ticket.delivery
      ? { ...ticket.delivery }
      : {
          unit_part_reports: ticket.unit_part_reports,
        },
  }))(UpdateDeliveryInfoForm)
  const selector = formValueSelector(DeliveryFormName)
  UpdateDeliveryInfoFormData = connect((state) => {
    const unit_part_reports = selector(state, 'unit_part_reports')
    return {
      unit_part_reports,
      editMode: ticket.delivery ? true : false,
    }
  })(UpdateDeliveryInfoFormData)
  return (
    <Slider
      title={ICONS.EDIT}
      size={"md"}
      header={
        <>
          <span className="mr-3">{ICONS.EDIT}</span>
          <span>Update Delivery</span>
        </>
      }
    >
      <UpdateDeliveryInfoFormData
        unit_parts={unit_part}
        onSubmit={createOrUpdateDeliveryInfo}
      />
    </Slider>
  )
}
